import { NgClass } from "@angular/common";
import {
    Component,
    inject,
    Input,
    OnInit,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IconComponent } from "@components/icon/icon.component";
import { PillboxComponent } from "@components/pillbox/pillbox.component";
import { RadiobuttonGroupComponent } from "@components/radiobuttongroup/radiobuttongroup.component";
import { filter, map, Subject, takeUntil } from "rxjs";
import { IRadiobuttonItem } from "~app/common/components/radiobuttongroup/radiobutton/IRadiobuttonItem";
import { Viol3Status } from "~app/common/models/constants";
import { IArbetsorderDetail } from "~app/features/planera/model/IArbetsorderDetail";
import { ArbetsorderEventStore, ArbetsorderEventStoreInfo } from "~app/features/shared/services/arbetsorderEventStore.service";
import { SetViolVersionCommand } from "../../commands/SetViolVersionCommand";

@Component({
    selector: "rask-arbetsorder-violversion-selector",
    templateUrl: "./arbetsorder-violversion-selector.component.html",
    styleUrls: ["./arbetsorder-violversion-selector.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        PillboxComponent,
        NgClass,
        IconComponent,
        RadiobuttonGroupComponent,
        FormsModule
    ]
})
export class ArbetsorderViolversionSelectorComponent implements OnInit {
    activetypes: IRadiobuttonItem[] = [
        { key: "false",
            value: "Viol 2" },
        { key: "true",
            value: "Viol 3" }
    ];
    @Input() arbetsorder: IArbetsorderDetail;
    isSending = false;
    isSent = false;
    viol3PilotAnvandare: boolean;
    violVersion = "false";

    private readonly arbetsorderEventStore = inject(ArbetsorderEventStore);
    private readonly unsubscribe$ = new Subject<void>();

    changeViolversion() {
        if (this.violVersion === "true") {
            this.arbetsorder.viol3 = true;
        } else {
            this.arbetsorder.viol3 = false;
        }

        this.arbetsorder.commandManager.addOrUpdate(new SetViolVersionCommand(c => {
            c.arbetsorderId = this.arbetsorder.id;
            c.viol3 = this.arbetsorder.viol3;
        }), c => c.$type === SetViolVersionCommand.$type);
    }

    getViolPillboxText() {
        return `Viol ${this.arbetsorder.viol3 ? "3" : "2"}`;
    }

    ngOnInit(): void {
        this.violVersion = this.arbetsorder.viol3 ? "true" : "false";

        this.arbetsorderEventStore.arbetsorderStoreEventsLoaded$
            .pipe(takeUntil(this.unsubscribe$))
            .pipe(filter(x => x.has(this.arbetsorder.id)), map(z => z.get(this.arbetsorder.id)))
            .subscribe(y => {
                this.setDataFromStore(y);
            });

        this.arbetsorderEventStore.arbetsorderSynchFinished$
            .pipe(takeUntil(this.unsubscribe$))
            .pipe(filter(x => x.arbetsorderId === this.arbetsorder.id))
            .subscribe(x => {
                this.setDataFromStore(x);
            });

        this.arbetsorderEventStore.arbetsorderSendStatusChanged$.pipe(takeUntil(this.unsubscribe$))
            .pipe(filter(x => x.arbetsorderId === this.arbetsorder.id))
            .subscribe(y => {
                this.setDataFromStore(y);
            });
    }

    violVersionIsDisabled(): boolean {
        return this.arbetsorder.isVirkeskop ||
            this.isSent ||
            this.isSending ||
            this.arbetsorder.isExternArbetsorder ||
            this.arbetsorder.isTerminalImport ||
            this.arbetsorder.viol3;
    }

    private setDataFromStore(y: ArbetsorderEventStoreInfo) {
        this.isSending = y.arbetsorderIsSending;
        this.isSent = y.statusProduktion === Viol3Status.Aktiv || y.statusTransport === Viol3Status.Aktiv;
    }
}
